import { Table, Text } from '@mantine/core';
import { i18nKeys } from 'locales/index';
import { useTranslation } from 'locales/logic';
import type { DebtorBalanceInvoice } from 'shared/hooks/use-load-debtor-balance';

import { NumberFormatterTable } from '../hooks/use-balance-table-columns';

import { makeSpacer } from './CreditNoteRow';

type InvoiceRowProps = {
  invoice: DebtorBalanceInvoice;
};

export const InvoiceRow = ({ invoice }: InvoiceRowProps) => {
  const { t } = useTranslation();

  const { totalTvac = 0, lateFees = 0, creditNotes = [], matchedPayments = [] } = invoice ?? {};

  return (
    <>
      {/* Amount billed */}
      <Table.Tr>
        {makeSpacer(1)}
        <Table.Td>
          <Text size="sm" fw={500}>
            {t(i18nKeys.AMOUNT_BILLED)}
          </Text>
        </Table.Td>
        {makeSpacer(2)}
        <Table.Td>
          <NumberFormatterTable value={totalTvac} />
        </Table.Td>
        {makeSpacer(2)}
      </Table.Tr>

      {/* Late fees */}
      {lateFees !== 0 && (
        <Table.Tr>
          {makeSpacer(1)}
          <Table.Td>
            <Text size="sm" fw={500}>
              {t(i18nKeys.LATE_FEES)}
            </Text>
          </Table.Td>
          {makeSpacer(3)}
          <Table.Td>
            <NumberFormatterTable value={lateFees} />
          </Table.Td>
          {makeSpacer(1)}
        </Table.Tr>
      )}

      {/* Credit notes */}
      {creditNotes.map(cn => (
        <Table.Tr key={cn.reference}>
          {makeSpacer(1)}
          <Table.Td>
            <Text size="sm" fw={500}>
              {t(i18nKeys.CREDIT_NOTE_LINKED)} – {cn.reference}
            </Text>
          </Table.Td>
          <Table.Td>
            <Text fw={500} size="sm">
              {cn.issueDate?.format('L') ?? t(i18nKeys.MISSING_DATA)}
            </Text>
          </Table.Td>
          {makeSpacer(2)}
          <Table.Td>
            <NumberFormatterTable value={cn.amount} />
          </Table.Td>
          {makeSpacer(1)}
        </Table.Tr>
      ))}

      {/* Linked payments */}
      {matchedPayments.map(p => (
        <Table.Tr key={`${p.communication}-${p.amount}`}>
          {makeSpacer(1)}
          <Table.Td>
            <Text size="sm" fw={500}>
              {t(i18nKeys.LINKED_PAYMENT)} – {p.communication}
            </Text>
          </Table.Td>
          <Table.Td>
            <Text size="sm" fw={500}>
              {p.issueDate?.format('L') ?? t(i18nKeys.MISSING_DATA)}
            </Text>
          </Table.Td>
          {makeSpacer(2)}
          <Table.Td>
            <NumberFormatterTable value={p.amount} />
          </Table.Td>
          {makeSpacer(1)}
        </Table.Tr>
      ))}
    </>
  );
};
